export default __webpack_public_path__ + "media/mobile/mobile-home-bg-15ec92bc.png";